export default __webpack_public_path__ + "static/kurzajki-b3a7b70dd11cd282d9e98ceb21505059.png";